import { ResizeMode } from '@wix/thumbnail-generator';
import classnames from 'classnames';
import { anyPass } from 'ramda';
import { noop } from 'ramda-adjunct';
import React, { FC, useCallback, useEffect, useRef } from 'react';
import { FileThumbnail } from '../../../components/common/Thumbnails/FileThumbnail';
import { FolderThumbnail } from '../../../components/common/Thumbnails/FolderThumbnail';
import { ListFileThumbnail } from '../../../components/layouts/List/ListFile/ListFileThumbnail';
import { MediaManagerSDKFile, MediaManagerSDKFolder } from '../../../utils/media-manager-sdk';
import { isFolder, isPictureFile, isTransparentVideoFile, isVideoFile } from '../../../utils/media-manager-sdk/items';
import styles from './ItemPreview.scss';
import { IOuter } from './ItemPreview.types';

const fillModeParams = { mode: ResizeMode.Fill };
const fitModeParams = { mode: ResizeMode.Fit };

export const ItemPreview: FC<IOuter> = ({ className, isActive, onClick, item, onBecomeActive = noop }) => {
  const itemPreviewElement = useRef();

  const handleClick = useCallback(() => onClick(item), [onClick, item]);

  useEffect(() => {
    if (isActive) {
      onBecomeActive(itemPreviewElement.current);
    }
  }, [isActive]);

  return (
    <div
      ref={itemPreviewElement}
      className={classnames(styles.item, { [styles.active]: isActive }, className)}
      onClick={handleClick}
      data-hook="item-preview"
    >
      {isFolder(item) ? (
        <FolderThumbnail
          className={styles.folder}
          folder={item as MediaManagerSDKFolder}
          small
          dark
          dataHook="item-preview-thumbnail-folder"
        />
      ) : isTransparentVideoFile(item as MediaManagerSDKFile) ? (
        <FileThumbnail
          file={item as MediaManagerSDKFile}
          width={72}
          height={72}
          params={fitModeParams}
          dataHook="item-preview-thumbnail-file"
        />
      ) : anyPass([isPictureFile, isVideoFile])(item as MediaManagerSDKFile) ? (
        <FileThumbnail
          file={item as MediaManagerSDKFile}
          width={72}
          height={72}
          params={fillModeParams}
          dataHook="item-preview-thumbnail-file"
        />
      ) : (
        <ListFileThumbnail
          file={item as MediaManagerSDKFile}
          width={72}
          height={72}
          params={fillModeParams}
          dataHook="item-preview-thumbnail-labeled-file"
        />
      )}
    </div>
  );
};
